export default {
  // KycRecordHistory.tsx
  'kyc.history.title': 'KYC Application History',
  'kyc.history.memberAccount': 'Member Account',
  'kyc.history.realName': 'Real Name',
  'kyc.history.idPhoto': 'ID Document',
  'kyc.infoImg.documentPhoto': 'Document Photo',
  'kyc.infoImg.handheldPhoto': 'Hand-held Document Photo',
  'kyc.infoImg.selfiePhoto': 'Selfie Photo',
  'kyc.infoImg.noPhoto': 'No Photo',
  'kyc.history.viewPhoto': 'View Photo',
  'kyc.history.birthDate': 'Date of Birth',
  'kyc.history.info': 'Basic information',
  'kyc.history.documentType': 'Document type',
  'kyc.history.documentCode': 'Document number',
  'kyc.history.gender': 'Gender',
  'kyc.history.nationality': 'Nationality',
  'kyc.history.incomeSource': 'Income source',
  'kyc.history.monthlyIncomeRange': 'Monthly Income Range',
  'kyc.history.occupation': 'Occupation',
  'kyc.history.currentAddress': 'Current address',
  'kyc.history.permanentAddress': 'Permanent address',
  'kyc.history.birthAddress': 'Birthplace',
  'kyc.history.kycCount': 'Application Count',
  'kyc.history.operation': 'Operation Info',
  'kyc.history.submitTime': 'Submit Time',
  'kyc.history.submitter': 'Submitter',
  'kyc.history.reviewTime': 'Review Time',
  'kyc.history.reviewer': 'Reviewer',
  'kyc.history.failureReason': 'Failure Reason',
  'kyc.history.status': 'Status',
  'kyc.history.status.simple.pending': 'Register KYC pending review',
  'kyc.history.status.whole.pending': 'Withdraw KYC pending review',
  'kyc.history.status.simple.success': 'Register KYC success',
  'kyc.history.status.whole.success': 'Withdraw KYC success',
  'kyc.history.status.simple.failed': 'Register KYC failed',
  'kyc.history.status.whole.failed': 'Withdraw KYC failed',
  'kyc.history.status.simple.blacklist': 'Register KYC blacklist',
  'kyc.history.status.whole.blacklist': 'Withdraw KYC blacklist',
  'kyc.history.status.unknown': 'Unknown',

  'kyc.sup.status.pending': 'Not submitted',
  'kyc.sup.status.submit': 'Submitted',
  'kyc.sup.status.rejected': 'Rejected',
  'kyc.sup.status.approved': 'Approved',
  'kyc.sup.approve.confirm.approve': 'Confirm that the request to supplement the member KYC information has been approved?',
  'kyc.sup.approve.confirm.reject': 'Confirm that the request to supplement the member KYC information should be rejected?',

  // KycRecordApprove.tsx
  'kyc.approve.title.success': 'Approve Confirmation',
  'kyc.approve.title.reject': 'Reject Confirmation',
  'kyc.update.title.document': 'Update Document',
  'kyc.approve.confirm.success': 'Confirm to set this KYC application as approved?',
  'kyc.approve.failureReason': 'Failure Reason',
  'kyc.approve.failureReason.placeholder': 'Please enter failure reason',
  'kyc.approve.error.recordNotExist': 'Record data does not exist',

  // KycRecordData.tsx
  'kyc.data.setSuccess': 'Set as Success',
  'kyc.data.setFailed': 'Set as Failed',
  'kyc.data.viewFailureReason': 'View Failure Reason',
  'kyc.data.viewHistory': 'View History',
  'kyc.data.document': 'Update Document',
  'kyc.data.confirm.setFailed': 'Confirm to set this KYC application as failed?',
  'kyc.data.error.loadFailed': 'Failed to load data',

  // KycRecordFrm.tsx
  'kyc.form.submitTime': 'Submit Time',
  'kyc.form.reviewTime': 'Review Time',
  'kyc.form.memberAccount': 'Member Account',
  'kyc.form.memberAccount.placeholder': 'Please enter member account',
  'kyc.form.status': 'Status',
  'kyc.form.status.placeholder': 'Please select status',
  'kyc.form.status.pending': 'Pending',
  'kyc.form.status.success': 'Approved',
  'kyc.form.status.failed': 'Rejected',
  'kyc.form.batchSuccess': 'Batch Set as Success',
  'kyc.form.batchFailed': 'Batch Set as Failed',
  'kyc.form.confirm.batchFailed': 'Confirm to set selected KYC applications as failed?',

  // System Common
  'sys.operation.title': 'Operation'
};
